import { render } from "./ClientLoginComponent.vue?vue&type=template&id=550fa3ca&scoped=true"
import script from "./ClientLoginComponent.vue?vue&type=script&lang=js"
export * from "./ClientLoginComponent.vue?vue&type=script&lang=js"

import "./ClientLoginComponent.vue?vue&type=style&index=0&id=550fa3ca&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-550fa3ca"]])

export default __exports__
import QForm from 'quasar/src/components/form/QForm.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QForm,QSpinner,QInput,QIcon,QBtn});
